import { curationService } from '../services';
import { curationConstants } from '../constants';

export const curationActions = {
  getIdeas,
  getIdeasMobile,
  toggleFilter,
  setFilters,
  filterIdeas,
  setStatusToFilter,
  clearFilters,
  clearFiltersNotStatus,
};

function getIdeas(page, sort = { created: -1 }, query, limit, statusCode) {
  return (dispatch) => {
    dispatch(request());
    curationService
      .getIdeas(page, sort, query, limit, statusCode)
      .then((ideas) => {
        dispatch(success(ideas));
      })
      .catch((error) => {
        dispatch(failure(error));
      });
  };

  function request() {
    return { type: curationConstants.GET_IDEAS_CURATION_REQUEST };
  }

  function success(ideas) {
    const payload = {
      ideas,
    };

    return { type: curationConstants.GET_IDEAS_CURATION_SUCCESS, payload };
  }

  function failure(error) {
    return { type: curationConstants.GET_IDEAS_CURATION_FAILURE };
  }
}

function getIdeasMobile(page, sort = { created: -1 }, query, limit, statusCode) {
  return (dispatch) => {
    dispatch(request());
    curationService
      .getIdeas(page, sort, query, limit, statusCode)
      .then((ideas) => {
        dispatch(success(ideas));
      })
      .catch((error) => {
        dispatch(failure(error));
      });
  };

  function request() {
    return { type: curationConstants.GET_IDEAS_CURATION_REQUEST };
  }

  function success(ideas) {
    const payload = {
      ideas,
    };

    return { type: curationConstants.GET_IDEAS_CURATION_MOBILE_SUCCESS, payload };
  }

  function failure(error) {
    return { type: curationConstants.GET_IDEAS_CURATION_FAILURE };
  }
}

function setFilters(name, value) {

  return dispatch => {
    dispatch(success());
  };

  function success() {
    const payload = {
      name, value
    };

    return { type: curationConstants.SET_FILTERS, payload}
  };

}

function filterIdeas(body) {
  return dispatch => {
    dispatch({ type: curationConstants.GET_IDEAS_CURATION_REQUEST });
    curationService.filter(body).then(data => dispatch(success(data)))
  };

  function success(ideas) {
    const payload = { ideas }
    return {type: curationConstants.GET_IDEAS_CURATION_SUCCESS, payload}
  };
}

function setStatusToFilter(status) {
  return dispatch => dispatch({ type: curationConstants.SET_STATUS_CODE_TO_FILTER, status });
};

function clearFilters() {
  return dispatch => dispatch({ type: curationConstants.CLEAR_FILTERS });
}

function clearFiltersNotStatus() {
  return dispatch => dispatch({ type: curationConstants.CLEAR_FILTERS_NOT_STATUS });

}

function toggleFilter(filter) {
  return (dispatch) => {
    dispatch(success());

    function success() {
      const payload = {
        filter,
      };
      return { type: curationConstants.TOGGLE_FILTER, payload };
    }
  };
}
